import { render, staticRenderFns } from "./OneThreeImageGrid.vue?vue&type=template&id=47c30352"
import script from "./OneThreeImageGrid.vue?vue&type=script&lang=js"
export * from "./OneThreeImageGrid.vue?vue&type=script&lang=js"
import style0 from "./OneThreeImageGrid.vue?vue&type=style&index=0&id=47c30352&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CImage: require('/vercel/path0/components/ui/c-image.vue').default})
